import angular from 'angular';
import badge from './badge';

export default angular.module('components.badge', []).component('badge', badge)
  .name;
